// src/redux/slices/industriesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { industriesService } from '../../services/industriesService.js'
import { handleApiError } from '../../utils/handleApiError.js'

export const fetchIndustries = createAsyncThunk(
    'industries/fetchIndustries',
    async (params = {}, { rejectWithValue }) => {
        try {
            const response = await industriesService.getIndustries(params)
            return response
        } catch (error) {
            return rejectWithValue(handleApiError(error))
        }
    }
)

export const fetchIndustryBySlug = createAsyncThunk(
    'industries/fetchIndustryBySlug',
    async (slug, { rejectWithValue }) => {
        try {
            const response = await industriesService.getIndustryBySlug(slug)
            return response
        } catch (error) {
            return rejectWithValue(handleApiError(error))
        }
    }
)

const industriesSlice = createSlice({
    name: 'industries',
    initialState: {
        industries: [],
        currentIndustry: null,
        loading: false,
        error: null
    },
    reducers: {
        clearCurrentIndustry: (state) => {
            state.currentIndustry = null
        },
        clearError: (state) => {
            state.error = null
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch Industries
            .addCase(fetchIndustries.pending, (state) => {
                state.loading = true
            })
            .addCase(fetchIndustries.fulfilled, (state, action) => {
                state.loading = false
                state.industries = action.payload.data.industries || action.payload
                state.error = null
            })
            .addCase(fetchIndustries.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
            // Fetch Industry by Slug
            .addCase(fetchIndustryBySlug.pending, (state) => {
                state.loading = true
            })
            .addCase(fetchIndustryBySlug.fulfilled, (state, action) => {
                state.loading = false
                state.currentIndustry = action.payload.data.industry
                state.error = null
            })
            .addCase(fetchIndustryBySlug.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
    }
})

export const { clearCurrentIndustry, clearError } = industriesSlice.actions
export default industriesSlice.reducer